var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_9250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H8.75C9.44036 5 10 5.55964 10 6.25V12.5C10 13.1904 9.44036 13.75 8.75 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V6.25C1.25 5.55964 1.80964 5 2.5 5Z",
    stroke: "#51CDA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C13.1875 10 13.75 9.4375 13.75 8.75V2.5C13.75 1.8125 13.1875 1.25 12.5 1.25H6.25C5.5625 1.25 5 1.8125 5 2.5",
    stroke: "#51CDA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_9250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.766c347355a7c9bb3d3dd49a28ba9ce0.svg";
export { ForwardRef as ReactComponent };